export default "__VITE_ASSET__DaTVaw2q__"